


import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { PersonCircle, PencilSquare } from 'react-bootstrap-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import {franc} from "franc";
import io from "socket.io-client";
import ChatMobile from "../components/ChatMobile";
import useWindowWidth from "../components/useWindowWidth";
import {
  Offcanvas,
  Row,
  Col,
  ListGroup,
  Button,
  Form,
  Spinner
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "../components/Layout";
import moment from "moment";
import Image from "../assets/img/messages.jpg";
import { BASE_URL } from "../constants";
const socket = io(BASE_URL, { transports: ["websocket"] });
export default function ChatContainer(props) {

  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [noShelterMessage, setNoShelterMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [lastMessages, setLastMessages] = useState([]);
  const [allMessages, setAllMessages] = useState([]);
  const [receivedMessageCounts, setReceivedMessageCounts] = useState({});
  const [receiverId, setReceiverId] = useState(null);
  const [showSidebar, setShowSidebar] = useState(false);
  const [users, setUsers] = useState([]);
  const [activeChat, setActiveChat] = useState(null); 
  const [fromLanguage, setFromLanguage] = useState('en'); 
  const [toLanguage, setToLanguage] = useState('en'); 
  const [showSidebarContacts, setShowSidebarContacts] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [shelters, setShelters] = useState([]);
  const [selectedShelterId, setSelectedShelterId] = useState('');
  const [favoriteShelters, setFavoriteShelters] = useState([]);



  const user = JSON.parse(localStorage.getItem('userData'));
  const userId = user?.id;
  const shelterId = user?.shelter?.id;
  const token = localStorage.getItem('token');
  const chatEndRef = useRef(null);
  const sidebarRef = useRef(null);
  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      toggleSidebar(); // Close the sidebar when clicking outside
    }
  };
 


  const handleBack = () => {
    setActiveChat(null);
  };
  const width = useWindowWidth();
  useEffect(() => {
    if (showSidebar) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    
    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSidebar]);
  const fetchUsers = async (shelterIdToUse = shelterId) => {
    if (!user || !user.id) {
      console.warn("User is undefined or missing ID.");
      return;
    }
  
    try {
      const response = await axios.get(`${BASE_URL}/shelters/users/${shelterIdToUse}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      const filteredUsers = response.data.filter((u) => u._id !== user.id);
      setUsers(filteredUsers);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };
  const fetchShelters = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/shelters`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setShelters(response.data);
    } catch (error) {
      console.error('Error fetching shelters:', error);
    }
  };
  useEffect(() => {
    fetchUsers();
    fetchShelters();
  }, []);
  useEffect(() => {
    if (!userId) return;
  
    const fetchAllMessages = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/messages/user/${userId}`, {
          headers: { 'Authorization': `Bearer ${token}` },
        });
        setAllMessages(response.data);
        const initialCounts = response.data.reduce((acc, message) => {
          const contactId = message.sender._id === userId ? message.receiver._id : message.sender._id;
          if (message.receiver === userId) {
            acc[contactId] = (acc[contactId] || 0) + 1;
          }
          return acc;
        }, {});
        setReceivedMessageCounts(initialCounts);
      } catch (error) {
        console.error('Error fetching all messages errr:', error);
      }
    };
  
     

    
    
  
    fetchAllMessages();

    socket.on('newMessage', (newMessage) => {
      if (newMessage.receiver === userId || newMessage.sender === userId) {
        setAllMessages((prevMessages) => {
          const updatedMessages = [...prevMessages, newMessage];
          return updatedMessages;
        });
  
        setReceivedMessageCounts((prevCounts) => ({
          ...prevCounts,
          [newMessage.sender._id]: (prevCounts[newMessage.sender._id] || 0) + 1
        }));
  
        if (receiverId && (newMessage.receiver === receiverId || newMessage.sender === receiverId)) {
          setMessages((prevMessages) => [...prevMessages, newMessage]);
        }
      }
    });
  
    return () => {
      socket.off('newMessage');
    };
  }, [userId, token, receiverId]);
  
  const markMessageAsRead = async (senderId) => {
    try {
      await axios.patch(`${BASE_URL}/messages/mark-read/${senderId}`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      console.error('Failed to mark messages from sender as read:', error);
    }
  };
  useEffect(() => {
    if (!userId || !receiverId) return;
  
    const fetchMessages = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/messages/${receiverId}/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
    
        setMessages(response.data);
    
        // Mark all unread messages from receiverId to current user as read
        const hasUnreadMessages = response.data.some(
          (msg) => !msg.isRead && msg.receiver._id === userId
        );
    
        if (hasUnreadMessages) {
          await markMessageAsRead(receiverId);
        }
    
        setReceivedMessageCounts((prevCounts) => ({
          ...prevCounts,
          [receiverId]: 0,
        }));
      } catch (error) {
        console.error('Error fetching messages:', error);
      }
    };
    
  
    fetchMessages();
    setActiveChat(receiverId);
  }, [receiverId, userId, token]);
  
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleFile = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      const preview = URL.createObjectURL(selectedFile);
      setPreviewUrl(preview);
   
    }
  };
  const fetchUnreadCount = async (senderId) => {
    try {
      const res = await axios.get(`${BASE_URL}/messages/unread/${senderId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      return res.data.count || 0;
    } catch (error) {
      console.error("Failed to fetch unread count for:", senderId, error);
      return 0;
    }
  };
  const loadUnreadCounts = useCallback(async () => {
    const counts = {};
  
    for (const message of lastMessages) {
      const contactId =
        message.sender._id === userId ? message.receiver._id : message.sender._id;
  
      if (!counts[contactId]) {
        const count = await fetchUnreadCount(contactId);
        counts[contactId] = count;
      }
    }
  
    setReceivedMessageCounts(counts);
  }, [lastMessages, userId]);

  useEffect(() => {
    if (lastMessages.length > 0) {
      loadUnreadCounts();
    }
  }, [lastMessages, loadUnreadCounts]);
  
  const sendMessage = async (e) => {
    if (e) e.preventDefault();

    if ((message.trim() || file) && receiverId) {
      setLoading(true);
      try {
        const [senderRes, receiverRes] = await Promise.all([
          axios.get(`${BASE_URL}/users/${userId}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${BASE_URL}/users/${receiverId}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        const formData = new FormData();
        formData.append('receiverId', receiverId);

        if (message.trim()) {
          formData.append('content', message.trim());
        }

        if (file) {
          formData.append('file', file);
        }

        // Use selected languages from dropdowns here
        formData.append('fromLang', fromLanguage);
        formData.append('toLang', toLanguage);

        const res = await axios.post(`${BASE_URL}/messages`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const savedMessage = res.data.data;

        const newMessage = {
          _id: savedMessage._id,
          content: savedMessage.content === "undefined" ? null : savedMessage.content,
          file: savedMessage.file || null,
          sender: {
            _id: senderRes.data._id,
            firstName: senderRes.data.firstName,
            lastName: senderRes.data.lastName,
            profilePhoto: senderRes.data.profilePhoto,
          },
          receiver: {
            _id: receiverRes.data._id,
            firstName: receiverRes.data.firstName,
            lastName: receiverRes.data.lastName,
            profilePhoto: receiverRes.data.profilePhoto,
          },
          timestamp: savedMessage.timestamp,
          isRead: false,
        };

        socket.emit('newMessage', newMessage);

        if (
          receiverId === newMessage.receiver._id ||
          receiverId === newMessage.sender._id
        ) {
          setMessages((prevMessages) => [...prevMessages, newMessage]);
        }

        setLastMessages(prev => {
        
          const contactId =
            newMessage.sender._id === userId
              ? newMessage.receiver._id
              : newMessage.sender._id;
        
      
          const filtered = prev.filter(m => {
            const cId = m.sender._id === userId ? m.receiver._id : m.sender._id;
            return cId !== contactId;
          });
        
      
          return [newMessage, ...filtered];
        });
        

        setMessage('');
        setFile(null);
        setPreviewUrl(null);
      } catch (error) {
        console.error('Error fetching user or sending message:', error);
      } finally {
        setLoading(false); 
      }
    } else {
      console.error('Message or receiverId is missing');
    }
  };
  

  
  
  useEffect(() => {
    const initialMessagesByContact = allMessages.reduce((acc, message) => {
      const contactId = message.sender._id === userId ? message.receiver._id : message.sender._id;
      if (!acc[contactId] || new Date(message.createdAt) > new Date(acc[contactId].createdAt)) {
        acc[contactId] = message;
      }
      return acc;
    }, {});
    setLastMessages(Object.values(initialMessagesByContact));
  }, [allMessages, userId]);
  
  const handleSelectChat = (contactId) => {
    setReceiverId(contactId);
    loadUnreadCounts(); 
  };
  

  

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleUserSelect = (selectedUserId) => {
    setReceiverId(selectedUserId);
    setShowSidebarContacts(false);
  };



  return width < 768 ? (
    // 👉 Mobile view
 <ChatMobile
    {...props}
      activeChat={activeChat}
      handleSelectChat={handleSelectChat}
      onBack={handleBack}
      userId={userId}
      users={users}
      lastMessages={lastMessages}
      messages={messages}
    setUsers={setUsers}
    user={user}
    shelterId={shelterId}
  file={file}
  setFile={setFile}
  handleUserSelect={handleUserSelect}
  setPreviewUrl={setPreviewUrl}
     
      setMessage={setMessage}
      message={message}
      handleFile={handleFile}
      previewUrl={previewUrl}
   receiverId={receiverId}
      fromLanguage={fromLanguage}
      toLanguage={toLanguage}
      setFromLanguage={setFromLanguage}
      setToLanguage={setToLanguage}
      socket={socket}            
  setMessages={setMessages}    
  setLastMessages={setLastMessages} 
  receivedMessageCounts={receivedMessageCounts}
    />
  ) : (
    // 👉 Desktop view (your full layout)
    <Layout>
     
  <div className="container mt-3">
  {noShelterMessage ? (
     <div className="card mt-3">
     <div className="card-body">
       <p className="card-text"> You can't chat with anyone because you're not assigned to a shelter yet.</p>
     </div>
   </div>
  ) : (
    <Row className="h-100">
      {/* Contacts Sidebar */}
    

      {lastMessages.length > 0 && (
        
<Col
  xs={12}
  md={4}
  lg={3}
  className={`
    bg-white border-end p-3 rounded mb-3 mb-md-0
    d-md-block
  `}
  
>
  <div className="overflow-auto" style={{ maxHeight: "50vh" }}>
  <div className="d-flex justify-content-between align-items-center mb-3">
  <h5 className="fw-bold text-primary mb-0">Discussions</h5>
  <button onClick={() => setShowSidebarContacts(true)} style={{ background: "none", border: "none" }}>
  <FontAwesomeIcon icon={faPenToSquare} />
</button>

</div>


    {[...lastMessages]
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .map((lastMessage) => {
        const contactId =
          lastMessage.sender._id === userId
            ? lastMessage.receiver._id
            : lastMessage.sender._id;
        const receivedCount = receivedMessageCounts[contactId] || 0;
        const isActive = contactId === activeChat;
        const isConnected = users.find((user) => user._id === contactId)?.isConnected;
     

        return (
          <div
          key={lastMessage._id}
          className={`d-flex align-items-start p-2 mb-2 rounded position-relative ${
            isActive ? "bg-gray-600 text-white" : "bg-gray-200"
          }`}
          style={{ cursor: "pointer" }}
          onClick={() => handleSelectChat(contactId)}
        >
          {/* Avatar */}
          <div
            className="rounded-circle bg-white d-inline-flex justify-content-center align-items-center me-3"
            style={{ width: "36px", height: "36px", flexShrink: 0 }}
          >
            {lastMessage.sender._id !== userId && lastMessage.sender.profilePhoto ? (
              <img
                src={lastMessage.sender.profilePhoto}
                alt={`${lastMessage.sender.firstName} ${lastMessage.sender.lastName}`}
                className="rounded-circle"
                width="36"
                height="36"
              />
            ) : lastMessage.receiver._id !== userId && lastMessage.receiver.profilePhoto ? (
              <img
                src={lastMessage.receiver.profilePhoto}
                alt={`${lastMessage.receiver.firstName} ${lastMessage.receiver.lastName}`}
                className="rounded-circle"
                width="36"
                height="36"
              />
            ) : (
              <div
                className="bg-gray-500 text-white d-flex justify-content-center align-items-center rounded-circle"
                style={{ width: "36px", height: "36px" }}
              >
                <PersonCircle size={36} />
              </div>
            )}
          </div>
        
          {/* Name and message */}
          <div className="flex-grow-1">
            <div className="d-flex align-items-center">
              <p className="mb-0 fw-bold me-2">
                {lastMessage.sender._id === userId
                  ? lastMessage.receiver.firstName && lastMessage.receiver.lastName
                    ? `${lastMessage.receiver.firstName} ${lastMessage.receiver.lastName}`
                    : "Unknown"
                  : lastMessage.sender.firstName && lastMessage.sender.lastName
                  ? `${lastMessage.sender.firstName} ${lastMessage.sender.lastName}`
                  : "Unknown"}
              </p>
        
              {/* Online indicator */}
              {isConnected && (
                <div
                  className="rounded-circle bg-success"
                  style={{ width: "10px", height: "10px" }}
                />
              )}
            </div>
        
            <small className="text-muted d-block text-truncate" style={{ maxWidth: "85%" }}>
              {lastMessage.content ? (
                lastMessage.content
              ) : lastMessage.file ? (
                lastMessage.file.type.startsWith("image") ? (
                  <span>📷 Sent an Image</span>
                ) : lastMessage.file.type === "application/pdf" ? (
                  <span>📄 Sent a PDF Document</span>
                ) : (
                  <span>📁 Sent a File</span>
                )
              ) : (
                "No message content"
              )}
            </small>
          </div>
        
    
          {receivedCount > 0 && (
            <span
              className="badge bg-danger position-absolute"
              style={{ bottom: "10px", right: "6px" }}
            >
              {receivedCount}
            </span>
          )}
        </div>
        
        );
      })}
  </div>
</Col>



)}



      {/* Chat Section */}
      <Col xs={10} md={8} lg={8} className="d-flex flex-column">

  {/* Chat Header */}
  <div className="border-bottom p-2 bg-white d-flex align-items-center rounded-top">
    {activeChat ? (
      <>
        <div
          className="bg-gray-500 text-white d-flex justify-content-center align-items-center rounded-circle"
          style={{ width: "36px", height: "36px" }}
        >
          {users.find((user) => user._id === activeChat)?.profilePhoto ? (
            <img
              src={users.find((user) => user._id === activeChat)?.profilePhoto}
              alt="active chat avatar"
              className="rounded-circle"
              width="36"
              height="36"
            />
          ) : (
            <div
              className="bg-gray-500 text-white d-flex justify-content-center align-items-center rounded-circle"
              style={{ width: "36px", height: "36px" }}
            >
              <PersonCircle size={36} />
            </div>
          )}
        </div>
        <div className="ms-2">
  <h6 className="mb-0 fw-bold">
    {users.find((user) => user._id === activeChat)?.firstName}{" "}
    {users.find((user) => user._id === activeChat)?.lastName}
  </h6>
  <small className="text-muted">
    {users.find((user) => user._id === activeChat)?.isConnected
      ? "Online"
      : "Offline"}
  </small>
</div>

      </>
    ) : (
      <Col className="bg-white p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bold text-primary mb-0">Chat</h5>
    
        {lastMessages.length === 0 && (
          <button
            onClick={() => setShowSidebarContacts(true)}
            style={{ background: "none", border: "none", cursor: "pointer" }}
            aria-label="Start new chat"
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>
        )}
      </div>
    </Col>
    
    )}
  </div>

  {/* Chat Messages Area */}
  <div
  className="flex-grow-1 overflow-auto p-3"
  style={{ backgroundColor: "#f8f9fa", height: "calc(50vh - 100px)" }}
>
  {!activeChat ? (
    
    <div className="text-center mt-2">
    <img
  src="https://www.svgrepo.com/show/356147/comment-dots.svg"
  alt="No conversation selected"
  className="img-fluid"
  style={{ width: "80px", opacity: 0.6 }}
/>

      <h4 className="fw-semibold mt-2">No conversation selected</h4>
      <p className="text-muted">Choose a user from the list to start chatting.</p>
    </div>
  ) : messages.length === 0 ? (
    // CASE 2: User selected but no messages yet
    <div className="text-center mt-2">
      <img
       src={Image}
        alt="Empty chat"
        style={{ maxHeight: "120px", objectFit: "contain" }}
      />
      <h4 className="fw-semibold mt-2">No messages yet</h4>
      <p className="text-muted">Start a conversation by sending a message.</p>
    </div>
  ) : (
    // CASE 3: Messages available
    messages.map((msg, index) => (
      <div
        key={index}
        className={`d-flex ${
          msg.sender._id === userId ? "justify-content-end" : "justify-content-start"
        } mb-3`}
      >
        {/* Avatar */}
        <div
          className="d-flex justify-content-center align-items-center rounded-circle overflow-hidden"
          style={{ width: "36px", height: "36px", flexShrink: 0 }}
        >
          {msg.sender._id !== userId && msg.sender.profilePhoto ? (
            <img
              src={msg.sender.profilePhoto}
              alt={`${msg.sender.firstName} ${msg.sender.lastName}`}
              className="rounded-circle"
              width="36"
              height="36"
              style={{ objectFit: "cover" }}
            />
          ) : (
            <div
              className="bg-gray-500 text-white d-flex justify-content-center align-items-center rounded-circle"
              style={{ width: "36px", height: "36px" }}
            >
              <PersonCircle size={36} />
            </div>
          )}
        </div>

        {/* Message Bubble */}
        <div
          className={`chat-bubble rounded ${
            msg.file && /\.(jpe?g|png|gif|webp|bmp)$/i.test(msg.file.url)
              ? ""
              : msg.sender._id === userId
              ? "bg-gray-600 text-white p-3"
              : "bg-white p-3"
          }`}
          style={{
            maxWidth: "75%",
            width: "fit-content",
            marginLeft: msg.sender._id === userId ? "8px" : "12px",
            marginRight: msg.sender._id === userId ? "12px" : "8px",
            wordBreak: "break-word",
            whiteSpace: "pre-wrap",
            lineHeight: "1.4",
          }}
        >
          {/* Message Content */}
          {msg.content && !msg.file ? (
            <p className="mb-1">{msg.content}</p>
          ) : msg.file && msg.file.url ? (
            /\.(jpe?g|png|gif|webp|bmp)$/i.test(msg.file.url) ? (
              <div className="text-center">
                <img
                  src={msg.file.url}
                  alt="Sent image"
                  className="img-fluid"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "250px",
                    borderRadius: "10px",
                    objectFit: "cover",
                  }}
                />
              </div>
            ) : msg.file.type === "application/pdf" ? (
              <div className="text-center">
                <a href={msg.file.url} target="_blank" rel="noopener noreferrer">
                  📄 View PDF
                </a>
              </div>
            ) : (
              <div className="text-center">
                <a href={msg.file.url} target="_blank" rel="noopener noreferrer">
                  📁 Download File
                </a>
              </div>
            )
          ) : null}

          <small className="text-muted d-block text-end">
            {moment(msg.createdAt).format("LT")}
          </small>
        </div>
      </div>
    ))
  )}
</div>


  {/* Chat Input Area (always present) */}
  <div className="rounded-bottom p-3 bg-white">
    {activeChat ? (
      <div className="d-flex flex-wrap align-items-center">
        {previewUrl && (
          <div className="me-2 mb-2" style={{ flexShrink: 0 }}>
            {file?.type?.startsWith("image") ? (
              <img
                src={previewUrl}
                alt="Preview"
                style={{
                  width: "60px",
                  height: "60px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            ) : file?.type === "application/pdf" ? (
              <a
                href={previewUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                📄 View PDF
              </a>
            ) : null}
          </div>
        )}

<Form.Control
  as="textarea"
  rows={1}
  placeholder="Type a message..."
  value={message}
  onChange={(e) => setMessage(e.target.value)}
  onKeyDown={(e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();       
      if (message.trim()) {
        sendMessage();        
      }
    }
  }}
  className="me-2 mb-2 flex-grow-1 rounded-pill"
  style={{
    minWidth: "150px",
    maxWidth: "100%",
    overflow: "hidden",
    resize: "none",
    fontSize: "16px",
  }}
/>



        <select
          value={fromLanguage}
          onChange={(e) => setFromLanguage(e.target.value)}
          className="form-select me-2 mb-2"
          style={{ borderRadius: "20px", minWidth: "100px", maxWidth: "120px" }}
        >
         <option value="en">English</option>
  <option value="ar">Arabic</option>
  <option value="de">Deutsch</option>
  <option value="ru">Russian</option>
  <option value="uk">Ukrainian</option>
  <option value="ku">Kurdish</option>
  <option value="tr">Turkish</option>
        </select>

        <select
          value={toLanguage}
          onChange={(e) => setToLanguage(e.target.value)}
          className="form-select me-2 mb-2"
          style={{ borderRadius: "20px", minWidth: "100px", maxWidth: "120px" }}
        >
         <option value="en">English</option>
  <option value="ar">Arabic</option>
  <option value="de">Deutsch</option>
  <option value="ru">Russian</option>
  <option value="uk">Ukrainian</option>
  <option value="ku">Kurdish</option>
  <option value="tr">Turkish</option>
        </select>

        <div className="me-2 mb-2" style={{ flexShrink: 0 }}>
          <label
            htmlFor="file-upload"
            className="btn btn-primary rounded-circle p-2"
            style={{ width: "40px", height: "40px" }}
          >
            <i className="fas fa-paperclip"></i>
          </label>
          <input
            id="file-upload"
            type="file"
            style={{ display: "none" }}
            accept="image/*,.pdf"
            onChange={handleFile}
          />
        </div>

        <Button
  variant="primary"
  onClick={sendMessage}
  className="rounded-circle p-2 mb-2"
  style={{ width: "40px", height: "40px", flexShrink: 0 }}
  disabled={loading}
>
  {loading ? (
    <Spinner animation="border" size="sm" role="status" />
  ) : (
    <i className="fas fa-paper-plane"></i>
  )}
</Button>

      </div>
    ) : (
      <div className="text-center text-muted py-3" style={{ minHeight: "80px" }}>

    </div>
    
    )}
  </div>
</Col>

 {/* Sidebar Section */}
 <Offcanvas
  show={showSidebarContacts}
  onHide={() => setShowSidebarContacts(false)}
  placement="end"
  backdrop={true}
  style={{ maxWidth: '300px' }}
>
  <Offcanvas.Header>
    <Offcanvas.Title>New Chat</Offcanvas.Title>
  </Offcanvas.Header>
  <Offcanvas.Body>
  <>
    <Form.Select
      className="mb-3"
      value={selectedShelterId}
      onChange={(e) => {
        const selectedId = e.target.value;
        setSelectedShelterId(selectedId);
        fetchUsers(selectedId);
      }}
    >
      <option value="">Select Shelter</option>
      {shelters
        .filter((shelter) => shelter._id !== user.shelterId)
        .map((shelter) => (
          <option key={shelter._id} value={shelter._id}>
            {shelter.name}
          </option>
        ))}
    </Form.Select>
  </>


    {/* Search input */}
    <Form.Control
      type="text"
      placeholder="Search user..."
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      className="mb-3"
    />

    {/* Users list */}
    <ListGroup>
      {users
        .filter((user) =>
          `${user.firstName} ${user.lastName}`
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
        )
        .map((user) => (
          <ListGroup.Item
            key={user._id}
            action
            onClick={() => handleUserSelect(user._id)}
            className={user._id === activeChat ? "bg-gray-600 text-white rounded" : ""}
          >
            <div className="d-flex align-items-center">
              {user.profilePhoto ? (
                <img
                  src={user.profilePhoto}
                  alt={`${user.firstName} ${user.lastName}`}
                  className="rounded-circle me-3"
                  width="36"
                  height="36"
                />
              ) : (
                <div
                  className="bg-gray-500 text-white d-flex justify-content-center align-items-center rounded-circle me-3"
                  style={{ width: "36px", height: "36px" }}
                >
                  <PersonCircle size={36} />
                </div>
              )}
              <div>
                <p className="mb-0 fw-bold">
                  {user.firstName && user.lastName
                    ? `${user.firstName} ${user.lastName}`
                    : "Unknown"}
                </p>
              </div>
              {user.isConnected && (
                <div
                  className="rounded-circle bg-success ms-auto"
                  style={{ width: "10px", height: "10px" }}
                />
              )}
            </div>
          </ListGroup.Item>
        ))}
    </ListGroup>

  </Offcanvas.Body>
</Offcanvas>




  </Row>
  )}
  </div>
</Layout>

  );
}